import React, { createContext, useContext } from "react";
import { useUnitsViewModel } from "./useUnitsViewModel";

type UnitsContextValue = ReturnType<typeof useUnitsViewModel>;

const UnitsContext = createContext<UnitsContextValue | null>(null);

export const UnitsProvider = ({ children }: { children: React.ReactNode }) => {
  const contextValue = useUnitsViewModel();

  return <UnitsContext.Provider value={contextValue}>{children}</UnitsContext.Provider>;
};

export const useUnits = (): UnitsContextValue => {
  const context = useContext(UnitsContext);

  if (!context) {
    throw new Error("useUnits must be used within UnitsProvider.");
  }

  return context;
};
